import CityPageTemplate from "../city-template/CityPageTemplate";
import { germantownConfig } from "./data";

export default function GermantownPage() {
  return <CityPageTemplate config={germantownConfig} />;
}